var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAppVersion)?_c('div',{staticClass:"app-version bg-EXPONDO-red text-center z-10 relative"},[_c('span',{staticClass:"text-EXPONDO-white"},[_vm._v("\n    App version: "+_vm._s(_vm.appVersion)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }